export default __webpack_public_path__ + "static/command-411f8640ddc9ab410e15a8090cd07151.png";